<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("require-file.title") }}
                </p>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{ action.title }}</label>
                    <div class="control">
                        <div
                            class="file is-centered has-name is-boxed"
                            :class="{ 'is-danger': emptyFile }"
                        >
                            <label class="file-label">
                                <input
                                    ref="fileAnswerInput"
                                    type="file"
                                    class="file-input"
                                    @change="fileChange"
                                />
                                <span class="file-cta">
                                    <span class="file-icon">
                                        <i class="fas fa-upload"></i>
                                    </span>
                                    <span class="file-label">
                                        {{ $t("require-file.select-file") }}
                                    </span>
                                </span>
                                <span v-if="fileName" class="file-name">
                                    {{ fileName }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="save">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span> {{ $t("require-file.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "require-file",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: null,
            emptyFile: false,
        };
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
        fileName() {
            return this.answer === null ? null : this.answer.name;
        },
    },
    methods: {
        ...mapActions("actions", ["setActionAnswer"]),
        fileChange(event) {
            if (event.target.files !== undefined) {
                let file = event.target.files[0];
                this.answer = file;
                this.emptyFile = false;
                this.$refs.fileAnswerInput.value = "";
            }
        },
        async save() {
            if (this.answer === null) {
                this.emptyFile = true;
                return;
            } else {
                this.emptyFile = false;
            }
            let roomId = this.getConferenceId;
            // UPLOAD FILE TO API
            var formData = new FormData();
            formData.append("name", this.answer.name);
            formData.append("roomId", roomId);
            formData.append("actionId", this.action.id);
            formData.append("file", this.answer);

            let response = await RepositoryFactory.files.postFile(formData);
            let fileId = response.data;

            let actionResult = this.action;
            actionResult.answer = {
                fileId: fileId,
                fileName: this.answer.name,
            };
            this.setActionAnswer(actionResult);
            this.$emit("answered", {
                socketName: "SendFileActionAnswer",
                roomId: roomId,
                actionId: this.action.id,
                answer: actionResult.answer,
                type: this.action.type,
            });
            this.answer = null;
        },
    },
};
</script>